import type {
  CompanionDiagramGenerationInput,
  CompanionDiagramFocus,
  CompanionDiagramRecipe,
} from "@jurisui/companion/types";
import type { ArchitectureContext } from "./architecture-model";
export type DiagramRecipe = CompanionDiagramRecipe;
export type DiagramKind = DiagramRecipe["kind"];
export type DiagramFocus = CompanionDiagramFocus;
export type DiagramGenerationRequest = Omit<
  CompanionDiagramGenerationInput,
  "app" | "architecture"
> & {
  architecture: ArchitectureContext;
  presetId?: string;
  focus?: DiagramFocus;
};
export const DIAGRAM_KINDS: DiagramKind[] = [
  "network",
  "deployment",
  "dependency",
  "data-flow",
  "sequence",
];
export const DIAGRAM_KIND_LABELS: Record<DiagramKind, string> = {
  network: "Network",
  deployment: "Infrastructure",
  dependency: "Dependencies",
  "data-flow": "Data flow",
  sequence: "Sequence",
};
